export const ROW_PAGE_SIZE = 10;

// Time-range presets surfaced to the user via the RadioGroup in the expanded
// span detail view. The interval is chosen so the resulting chart shows ~60
// buckets across the selected window — fine enough to see structure without
// overwhelming the small sparkline.
export type ChartTimeRangeKey = '1h' | '24h' | '7d';
export const CHART_TIME_RANGES: Record<ChartTimeRangeKey, { durationMs: number; interval: 'minute' | 'hour' | 'day' }> =
  {
    '1h': { durationMs: 60 * 60 * 1000, interval: 'minute' },
    '24h': { durationMs: 24 * 60 * 60 * 1000, interval: 'hour' },
    '7d': { durationMs: 7 * 24 * 60 * 60 * 1000, interval: 'day' },
  };
export const DEFAULT_CHART_TIME_RANGE_KEY: ChartTimeRangeKey = '1h';

export const isChartTimeRangeKey = (value: string): value is ChartTimeRangeKey =>
  Object.prototype.hasOwnProperty.call(CHART_TIME_RANGES, value);
